import { ApiError } from '../instance/error';

type ErrorHandler = (error: ApiError) => void;

let handler: ErrorHandler | null = null;

export function setGlobalErrorHandler(fn: ErrorHandler) {
  handler = fn;
}

export function clearGlobalErrorHandler() {
  handler = null;
}

export function getGlobalErrorHandler(): ErrorHandler | null {
  return handler;
}
